import { render, staticRenderFns } from "./salesAgent.vue?vue&type=template&id=c6a60818"
import script from "./salesAgent.vue?vue&type=script&lang=js"
export * from "./salesAgent.vue?vue&type=script&lang=js"
import style0 from "./salesAgent.vue?vue&type=style&index=0&id=c6a60818&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports